import { render, staticRenderFns } from "./Charges.vue?vue&type=template&id=60e9a4f8&scoped=true"
import script from "./Charges.vue?vue&type=script&lang=js"
export * from "./Charges.vue?vue&type=script&lang=js"
import style0 from "./Charges.vue?vue&type=style&index=0&id=60e9a4f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e9a4f8",
  null
  
)

export default component.exports